import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError } from '@shared/helpers/form.helper';
import { isNilOrEmpty, toBoolean } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { formPaths } from '@shared/constants/form-paths.const';
import { MyAllElemCollegioSindacaleEntity, MyAllElemRevisoriControlloContabileEntity } from '../../../../models/interfaces/revisione.interface';
import {
    getNormeSrlControl,
    getAmmControlloControl,
    normeSrlCkHelper,
    normeSrlRequiredHelper,
    checkCkNormeValue,
    checkAllElemCollegioSindacale,
} from './helpers/norme-srl-form-validators.helper';

export const normeSrlOrganoControlloRules: FormGroupRules = {
    my_CkSrlSindaciRevisori: (form: FormGroup) => {
        const my_CkSrlSindaciRevisoriControl = getNormeSrlControl(form, 'my_CkSrlSindaciRevisori');
        const errors = my_CkSrlSindaciRevisoriControl.errors ? my_CkSrlSindaciRevisoriControl.errors : {};

        addRemoveError(isNilOrEmpty(my_CkSrlSindaciRevisoriControl?.value) && checkAllElemCollegioSindacale(form) && checkCkNormeValue(form), errors, 'my_CkSrlSindaciRevisori', {
            status: REQUIRED_STATUS,
        });

        my_CkSrlSindaciRevisoriControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSrlSindaciSceltiCoerenza: (form: FormGroup) => {
        normeSrlCkHelper(
            form,
            'my_NormeSrl.my_CkSrlSindaciSceltiCoerenza',
            'my_NormeSrl.my_CkSrlSindaciRevisori',
            0,
            formPaths.ammControllo,
            checkAllElemCollegioSindacale(form)
        );
    },

    my_CkSrlSindaciRelazionano: (form: FormGroup) => {
        const my_CkSrlSindaciRelazionanoControl = getNormeSrlControl(form, 'my_CkSrlSindaciRelazionano');
        const errors = my_CkSrlSindaciRelazionanoControl.errors ? my_CkSrlSindaciRelazionanoControl.errors : {};

        addRemoveError(
            isNilOrEmpty(my_CkSrlSindaciRelazionanoControl?.value) && checkAllElemCollegioSindacale(form) && checkCkNormeValue(form),
            errors,
            'my_CkSrlSindaciRelazionano',
            {
                status: REQUIRED_STATUS,
            }
        );

        my_CkSrlSindaciRelazionanoControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_SrlNoteComposCollSind: (form: FormGroup) => {
        const my_SrlNoteComposCollSindControl = getNormeSrlControl(form, 'my_SrlNoteComposCollSind');
        const errors = my_SrlNoteComposCollSindControl.errors ? my_SrlNoteComposCollSindControl.errors : {};

        addRemoveError(isNilOrEmpty(my_SrlNoteComposCollSindControl?.value) && checkAllElemCollegioSindacale(form) && checkCkNormeValue(form), errors, 'my_SrlNoteComposCollSind', {
            status: REQUIRED_STATUS,
        });

        my_SrlNoteComposCollSindControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSrlAffidamContrCont: (form: FormGroup) => {
        const my_CkSrlAffidamContrContControl = getNormeSrlControl(form, 'my_CkSrlAffidamContrCont');
        const my_CkSrlAffidamContrCont: string = my_CkSrlAffidamContrContControl?.value;
        const my_CkSrlAssembNominOrgano: string = getNormeSrlControl(form, 'my_CkSrlAssembNominOrgano').value;
        const my_AllElemRevisoriControlloContabile: MyAllElemRevisoriControlloContabileEntity[] = getAmmControlloControl(
            form,
            'my_AllRevisoriControlloContabile.my_AllElemRevisoriControlloContabile'
        ).value;
        const my_AllElemCollegioSindacale: MyAllElemCollegioSindacaleEntity[] = getAmmControlloControl(
            form,
            'my_AllCollegioSindacale.my_AllElemCollegioSindacale'
        ).value;
        const my_CalcObbOrganoContr: string = getAmmControlloControl(form, 'my_CalcObbOrganoContr').value;
        const conteggioAllElemRevisori = my_AllElemRevisoriControlloContabile?.length ?? 0;
        const errors = my_CkSrlAffidamContrContControl.errors ? my_CkSrlAffidamContrContControl.errors : {};

        addRemoveError(isNilOrEmpty(my_CkSrlAffidamContrCont) && checkCkNormeValue(form), errors, 'my_CkSrlAffidamContrCont', {
            status: REQUIRED_STATUS,
        });

        addRemoveError(my_CkSrlAffidamContrContControl.value === '3' && conteggioAllElemRevisori <= 1 && checkCkNormeValue(form), errors, 'my_CkSrlAffidamContrCont', {
            status: 'Inserire i revisori esterni',
        });

        addRemoveError(my_CkSrlAffidamContrContControl.value === '2' && conteggioAllElemRevisori != 1 && checkCkNormeValue(form), errors, 'my_CkSrlAffidamContrCont', {
            status: 'Inserire un revisore esterno',
        });

        addRemoveError(my_CkSrlAffidamContrCont === '7' && my_CkSrlAssembNominOrgano === '1' && checkCkNormeValue(form), errors, 'my_CkSrlAffidamContrCont', {
            status: 'Incongruenza con la risposta 6',
        });

        addRemoveError(my_CkSrlAffidamContrContControl.value === '5' && !my_AllElemCollegioSindacale?.length && checkCkNormeValue(form), errors, 'my_CkSrlAffidamContrCont', {
            status: 'Collegio sindacale non presente',
        });

        addRemoveError(my_CkSrlAffidamContrContControl.value === '8' && toBoolean(my_CalcObbOrganoContr) && checkCkNormeValue(form), errors, 'my_CkSrlAffidamContrCont', {
            status: 'Affidamento Revisione Legale',
            message: "Risulta l'obbligo di nomina",
        });

        my_CkSrlAffidamContrContControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_lblSrlContrContab: (form: FormGroup) => {
        const my_lblSrlContrContabControl = getNormeSrlControl(form, 'my_lblSrlContrContab');
        const my_CkSrlAffidamContrCont: string = getNormeSrlControl(form, 'my_CkSrlAffidamContrCont').value;
        const my_CkSrlAssembNominSind: string = getNormeSrlControl(form, 'my_CkSrlAssembNominSind').value;
        const my_AllElemCollegioSindacale: MyAllElemCollegioSindacaleEntity[] = getAmmControlloControl(
            form,
            'my_AllCollegioSindacale.my_AllElemCollegioSindacale'
        ).value;
        const errors = my_lblSrlContrContabControl.errors ? my_lblSrlContrContabControl.errors : {};

        addRemoveError(
            my_CkSrlAffidamContrCont === '5' && !my_AllElemCollegioSindacale?.length && my_CkSrlAssembNominSind === '1' && checkCkNormeValue(form),
            errors,
            'my_lblSrlContrContab',
            {
                status: "L'Organo di Controllo è obbligatorio se nominato e gli è stato affidata la Revisione Legale",
            }
        );

        my_lblSrlContrContabControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_SrlNoteComposContrContab: (form: FormGroup) => {
        normeSrlRequiredHelper(form, 'my_NormeSrl.my_SrlNoteComposContrContab');
    },
};
